const RetrieveImage = (ref) => {
	var baseURI = 'https://firebasestorage.googleapis.com/v0/b/micatalogovirtual-7bfd1.appspot.com/o/'+encodeURIComponent(ref.replace(/^\//, ''))+'?alt=media';
	return baseURI;
}

export default RetrieveImage;